import { create } from 'zustand';
import type { LoginOption } from '../../domain/entities/auth.entity';

interface InstitutionState {
  institutionName: string | null;
  courseId: string | null;
  showLoginModal: boolean;
  // Estado do fluxo de login/troca de turma — precisa ser compartilhado
  // porque quem dispara (ex.: botão "Trocar turma" no Header) e quem exibe
  // (LoginModal) são componentes diferentes.
  loginOptions: LoginOption[] | null;
  pendingToken: string | null;
  isSwitchingList: boolean;
  authLoading: boolean;
  authError: string | null;
  setInstitution: (name: string) => void;
  setCourseId: (courseId: string | null) => void;
  setShowLoginModal: (show: boolean) => void;
  setLoginOptions: (options: LoginOption[] | null) => void;
  setPendingToken: (token: string | null) => void;
  setIsSwitchingList: (value: boolean) => void;
  setAuthLoading: (value: boolean) => void;
  setAuthError: (value: string | null) => void;
}

export const useInstitutionStore = create<InstitutionState>((set) => ({
  institutionName: null,
  courseId: null,
  showLoginModal: false,
  loginOptions: null,
  pendingToken: null,
  isSwitchingList: false,
  authLoading: false,
  authError: null,
  setInstitution: (name) => set({ institutionName: name }),
  setCourseId: (courseId) => set({ courseId }),
  setShowLoginModal: (show) => set({ showLoginModal: show }),
  setLoginOptions: (options) => set({ loginOptions: options }),
  setPendingToken: (token) => set({ pendingToken: token }),
  setIsSwitchingList: (value) => set({ isSwitchingList: value }),
  setAuthLoading: (value) => set({ authLoading: value }),
  setAuthError: (value) => set({ authError: value }),
}));
